import React from "react";

export type InfoIconProps = {
  width?: number;
  height?: number;
  stroke?: string;
  strokeWidth?: number;
  ariaLabel?: string;
  style?: React.CSSProperties;
  className?: string;
  title?: string;
};

/**
 * Reusable Info Icon (20x21 viewBox). Default stroke #AFB6BA, width 20, height 21.
 * Matches the inline SVG previously used in PaymentContent100DayABCPlan.
 */
const InfoIcon: React.FC<InfoIconProps> = ({
  width = 20,
  height = 21,
  stroke = "#AFB6BA",
  strokeWidth = 1.6,
  ariaLabel,
  style,
  className,
  title,
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-label={ariaLabel}
      role={ariaLabel ? "img" : undefined}
      className={className}
      style={style}
    >
      {title ? <title>{title}</title> : null}
      <path d="M10 9.66663L10 13.8333" stroke={stroke} strokeWidth={strokeWidth} strokeLinecap="round" />
      <path d="M10 7.16663L10 7.16673" stroke={stroke} strokeWidth={strokeWidth} strokeLinecap="round" />
      <circle cx="10" cy="10.5" r="6.7" stroke={stroke} strokeWidth={strokeWidth} strokeLinecap="round" />
    </svg>
  );
};

export default InfoIcon;
